import './components/cta_discipline_matters';
import './components/subject_group_list';
import './components/summary';
import './index.scss';
import 'components/banner/signup_banner';
import 'components/button_follow';
import 'components/discipline_banner';
import 'components/discipline_course_banner';
import 'styles/components/_input-groups.scss';
import 'styles/components/_list-group.scss';
import 'styles/components/_panels.scss';
import zaraz from 'utils/trackers/zaraz';

(function ($) {
  const $page = $('.q-discipline-page');

  $('.collapse', $page)
    .on('show.bs.collapse', e => {
      const $toggle = $(e.currentTarget).prev('.q-heading').find('.q-toggle');

      $toggle.find('.q-open').addClass('hidden');
      $toggle.find('.q-close').removeClass('hidden');
    })
    .on('hide.bs.collapse', e => {
      const $toggle = $(e.currentTarget).prev('.q-heading').find('.q-toggle');

      $toggle.find('.q-open').removeClass('hidden');
      $toggle.find('.q-close').addClass('hidden');
    });

  $('#js-search-form', $page).on('submit', e => {
    e.preventDefault();

    const $form = $(e.currentTarget);
    const query = $('input', $form).val();

    $('.q-subject-group-list li', $page).removeClass('hidden');
    $('.q-subject-group-list .q-subject-group-item', $page).removeClass(
      'hidden'
    );

    if (query && query.length > 0) {
      $(
        '.q-subject-group-list li:not(:icontains("' + query + '"))',
        $page
      ).addClass('hidden');

      $('.q-subject-group-list .q-subject-group-item', $page).each(function () {
        const visibleChildren = $(this).find(
          '.list-group-item:not(.hidden)'
        ).length;
        const parentContains = $(this).find(
          'a:xcontains("' + query + '")'
        ).length;

        if (visibleChildren === 0 && parentContains === 0) {
          $(this).addClass('hidden');
        } else {
          $(this).find('.collapse').collapse('show');
        }
      });
    }
  });

  const $container = $('[data-event]');
  const eventData = $container.data('event') || {};

  const isSendEvent =
    eventData?.active && eventData?.zaraz_send_event && eventData?.event_props;

  if ($container && isSendEvent) {
    zaraz.set('show_experiment', 'true', { scope: 'persist' });
    zaraz.track(eventData.zaraz_event, eventData.event_props);
  }
})(jQuery);
